import uuid from 'uuid'

export const downloadKeystore = keystore => {
  const aLink = document.createElement('a')
  const blob = new Blob([JSON.stringify(keystore)])
  aLink.download = `${uuid.v4()}_keystore`
  aLink.href = URL.createObjectURL(blob)
  document.body.appendChild(aLink)
  aLink.click()
  window.URL.revokeObjectURL(aLink.href)
  aLink.remove()
}

export const isUnlockWithWalletConnect = () => {
  let storage = sessionStorage.getItem('user') || '{}'
  storage = JSON.parse(storage)
  return storage.flags && storage.flags.isWalletConnect
}

export default () => {
  let storage = sessionStorage.getItem('user') || '{}'
  storage = JSON.parse(storage)
  return !!storage.keystore
}
